import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandHeader from './components/BrandHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import FeatureHighlight from './components/FeatureHighlight';
import Icon from '../../components/AppIcon';

const LoginAuthentication = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (isAuthenticated === 'true') {
      navigate('/main-dashboard');
    }
  }, [navigate]);

  const handleBackToHome = () => {
    navigate('/public-landing-page');
  };

  return (
    <div className="min-h-screen bg-background flex">
      <div className="flex-1 flex flex-col justify-center px-6 py-12 lg:px-8">
        <button
          onClick={handleBackToHome}
          className="absolute top-6 left-6 flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors duration-150 group"
        >
          <Icon name="ArrowLeft" size={20} color="currentColor" />
          <span className="text-sm font-medium">Back to Home</span>
        </button>

        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <BrandHeader />
          <div className="bg-card rounded-lg shadow-elevation-2 border border-border p-8">
            <LoginForm />
            <SecurityBadges />
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} Bee Wise. All rights reserved.
          </p>
        </div>
      </div>
      <FeatureHighlight />
    </div>
  );
};

export default LoginAuthentication;